module.exports = __webpack_public_path__ + "img/logo.f4b0fb8b.svg";